export const OutlineText = ({ text }: { text: string }) => {
  return (
    <svg fontSize="1.6em" height="100%" width="100%">
      <text
        dominantBaseline="middle"
        style={{
          fontSize: '2.25em',
          fontWeight: '900',
          fill: '#fff',
          stroke: '#FF0ECA',
          strokeWidth: '0.1em',
          paintOrder: 'stroke', // Important: Stroke is drawn behind the fill
          strokeLinejoin: 'round',
          textShadow: 'none',
        }}
        textAnchor="middle"
        x="50%"
        y="72%"
      >
        {text}
      </text>
    </svg>
  );
};
